// Drag-to-scroll (mouse) + dot sync for the swipeable product card image gallery.
// Touch already scrolls natively, this only adds mouse/pen support and keeps
// a drag from also firing a navigation click on the slide link underneath it.
(function () {
  var DRAG_THRESHOLD = 6;
  var state = null;

  function trackFor(el) {
    return el.closest ? el.closest('.product-card__gallery-track') : null;
  }

  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType === 'touch') return;

    var track = trackFor(event.target);
    if (!track) return;

    state = {
      track: track,
      pointerId: event.pointerId,
      startX: event.clientX,
      startScrollLeft: track.scrollLeft,
      moved: false,
    };
    track.classList.add('is-dragging');
  });

  document.addEventListener('pointermove', function (event) {
    if (!state || event.pointerId !== state.pointerId) return;

    var delta = event.clientX - state.startX;
    if (Math.abs(delta) > DRAG_THRESHOLD) {
      state.moved = true;
    }
    state.track.scrollLeft = state.startScrollLeft - delta;
  });

  function endDrag(event) {
    if (!state || event.pointerId !== state.pointerId) return;

    var track = state.track;
    var moved = state.moved;
    track.classList.remove('is-dragging');

    var slideWidth = track.clientWidth;
    if (slideWidth > 0) {
      var index = Math.round(track.scrollLeft / slideWidth);
      track.scrollTo({ left: index * slideWidth, behavior: 'smooth' });
    }

    if (moved) {
      var suppressClick = function (clickEvent) {
        clickEvent.preventDefault();
      };
      track.addEventListener('click', suppressClick, { capture: true, once: true });
      window.setTimeout(function () {
        track.removeEventListener('click', suppressClick, { capture: true });
      }, 0);
    }

    state = null;
  }

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  document.addEventListener(
    'scroll',
    function (event) {
      var track = event.target;
      if (!track.classList || !track.classList.contains('product-card__gallery-track')) return;

      var dotsContainer = track.parentElement.querySelector('.product-card__gallery-dots');
      if (!dotsContainer) return;

      var slideWidth = track.clientWidth;
      if (slideWidth === 0) return;

      var index = Math.round(track.scrollLeft / slideWidth);
      var dots = dotsContainer.children;
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === index);
      }
    },
    true
  );
})();
